import { UtilsMisc } from '../../utils/utils.misc';

export interface IConfigData {

    cryptoKey?: string;
    ip?: string;
    port?: string;
    protocol?: string;
    retries?: number;
    retryDelay?: number;
    timeout?: number;
    urlApi?: string;
    version?: string;

}

// @dynamic
export class ConfigData {

    private static _cryptoKey: string = null;
    private static _ip: string = 'localhost';
    private static _port: string = '5001';
    private static _protocol: string = 'http';
    private static _retries: number = 3;
    private static _retryDelay: number = 1000;
    private static _timeout: number = 2000;
    private static _urlApi: string = 'api';
    private static _version: string = null;

    public static get cryptoKey(): string {
        return ConfigData._cryptoKey;
    }

    public static set cryptoKey(value: string) {
        ConfigData._cryptoKey = value;
    }

    public static get ip(): string {
        return ConfigData._ip;
    }

    public static set ip(value: string) {
        ConfigData._ip = value;
    }

    public static get port(): string {
        return ConfigData._port;
    }

    public static set port(value: string) {
        ConfigData._port = value;
    }

    public static get protocol(): string {
        return ConfigData._protocol;
    }

    public static set protocol(value: string) {
        ConfigData._protocol = value;
    }

    public static get retries(): number {
        return ConfigData._retries;
    }

    public static set retries(value: number) {
        ConfigData._retries = value;
    }

    public static get retryDelay(): number {
        return ConfigData._retryDelay;
    }

    public static set retryDelay(value: number) {
        ConfigData._retryDelay = value;
    }

    public static get timeout(): number {
        return ConfigData._timeout;
    }

    public static set timeout(value: number) {
        ConfigData._timeout = value;
    }

    public static get urlApi(): string {
        return ConfigData._urlApi;
    }

    public static set urlApi(value: string) {
        ConfigData._urlApi = value;
    }

    public static get version(): string {
        return ConfigData._version;
    }

    public static set version(value: string) {
        ConfigData._version = value;
    }

    public static assign(source: IConfigData): void {
        if (UtilsMisc.isNullOrUndefinedOrEmpty(source) === false) {
            ConfigData._cryptoKey = source.cryptoKey;
            ConfigData._ip = source.ip;
            ConfigData._port = source.port;
            ConfigData._protocol = source.protocol;
            ConfigData._retries = source.retries;
            ConfigData._retryDelay = source.retryDelay;
            ConfigData._timeout = source.timeout;
            ConfigData._urlApi = source.urlApi;
            ConfigData._version = source.version;
        }
    }

}
